import Select, { SelectProps } from './Select';

export type { SelectProps };
export default Select;
